export function getEventsListingRequestParamsFormatter(
  offset: number,
  limit: number,
  country?: number,
  city?: number,
  status?: string | null,
  type?: string | null,
  minDate?: string,
  maxDate?: string,
  isMyEvent?: boolean
): string {
  let queryParams = `?limit=${limit}&offset=${offset * limit}`;

  if (status) queryParams += `&status=${status}`;
  if (type) queryParams += `&type=${type}`;
  if (minDate) queryParams += `&dateMin=${minDate}`;
  if (maxDate) queryParams += `&dateMax=${maxDate}`;
  if (country) queryParams += `&countryId=${country}`;
  if (city) queryParams += `&cityId=${city}`;
  if (isMyEvent) queryParams += `&owner=ME`;

  return queryParams;
}

export function getEventsListingForGoPlayRequestParamsFormatter(minDate?: string, maxDate?: string): string {
  let queryParams = `?limit=10&offset=1`;
  if (minDate) queryParams += `&dateMin=${minDate}`;
  if (maxDate) queryParams += `&dateMax=${maxDate}`;
  return queryParams;
}
